module.exports = __webpack_public_path__ + "static/img/icon1.5d36cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/icon1.png
// module id = dVTP
// module chunks = 44